import { makeStyles } from "@material-ui/core/styles";
import {
  PrimaryColor,
  White,
  LightPrimaryColor,
  BackgroundBlue,
} from "../../shared/styles/colors";

export default makeStyles(() => ({
  homepage: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    background: BackgroundBlue,
  },
  carrouselDiv: {
    marginTop: "7rem",
    "@media (max-width: 640px)": {
      marginTop: "100px",
    },
  },
  carrouselBackground: {
    position: "absolute",
    width: "100%",
    height: "100%",
    backgroundImage:
      "linear-gradient(180deg, rgba(24, 47, 88, 0) 30%, #182F58 100%)",
    top: -25,
    zIndex: 1,
    "@media (min-width: 1536px)": {
      marginTop: "70px",
    },
    "@media (max-width: 1440px)": {
      marginTop: "80px"
    },
    "@media (max-width: 640px)": {
      top: 0,
    },
  },
  requestDiv: {
    display: "flex",
    position: "absolute",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "750px",
    bottom: "250px",
    zIndex: 2,
    "@media (max-width: 1440px)": {
      bottom: "150px",
    },
    "@media (max-width: 640px)": {
      top: 0,
      bottom: 0,
      width: "100%",
    },
  },
  requestService: {
    font: "verdana, sans-serif",
    fontSize: "2.5rem",
    fontWeight: "bold",
    color: White,
    "@media (max-width: 1440px)": {
      fontSize: "2rem",
    },
    "@media (max-width: 640px)": {
      fontSize: "1.5rem",
    },
  },
  request_button: {
    width: "auto",
    border: "none",
    padding: "10px",
    marginTop: "40px",
    cursor: "pointer",
    borderRadius: ".5rem",
    fontWeight: "700",
    color: PrimaryColor,
    backgroundColor: White,
    "&:hover": {
      //background: BackgroundBlue,
      transition: "transform 0.3s ease",
      transform: "translateY(-5px)",
    },
    "@media (max-width: 640px)": {
      fontSize: "0.7rem",
    },
  },
  request_div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: White,
    width: "100% !important",
  },
  request_img_and_background_div: {
    display: "flex",
    flexDirection: "column",
    width: "50%",
    "@media (max-width: 640px)": {
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
      width: "100%",
    },
  },
  request_color_bgd: {
    background: PrimaryColor,
    width: "20rem",
    height: "27.5rem",
    marginTop: "20px",
    marginBottom: "10%",
    borderRadius: "8%",
    "@media (max-width: 820px)": {
      width: "18rem",
      height: "28rem",
      marginTop: "5%",
      marginLeft: "18%",
    },
    "@media (max-width: 640px)": {
      width: "15rem",
      height: "16rem",
      marginTop: "10%",
      marginLeft: "0%",
    },
  },
  request_img: {
    width: "20rem",
    height: "28rem",
    position: "absolute",
    marginTop: "-10px",
    marginLeft: "2%",
    borderRadius: "8%",
    "@media (max-width: 820px)": {
      width: "18rem",
      height: "28rem",
      marginTop: "0%",
      marginLeft: "12%",
    },
    "@media (max-width: 640px)": {
      width: "15rem",
      height: "17rem",
      marginTop: "-12%",
      marginLeft: "10%",
    },
  },
  request_text_div: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    justifyContent: "center",
    width: "33rem",
    height: "14rem",
    padding: "4rem",
    borderRadius: "30px",
    marginLeft: "30%",
    marginTop: "17rem",
    backgroundColor: BackgroundBlue,
    "@media (min-width: 1536px)": {
      marginLeft: "15%",
      marginTop: "15%",
      width: "35rem",
    },
    "@media (max-width: 640px)": {
      position: "relative",
      width: "80%",
      height: "auto",
      marginLeft: "0%",
      marginTop: "0%",
      marginBottom: "7.5%",
      padding: "2rem",
      //TODO: fix phone icon styling behind this div on phones
    },
  },
  request_text: {
    width: "100%",
    fontSize: "2rem",
    fontWeight: "700",
    wordWrap: "break-word",
    color: PrimaryColor,
    margin: "10%",
    "@media (max-width: 640px)": {
      fontSize: "1.3rem",
      margin: "0%",
    },
  },
  text: {
    color: "#333333",
    fontSize: "1.5rem",
    textAlign: "start",
    fontWeight: "700",
    "@media (max-width: 640px)": {
      fontSize: "1.3rem",
      margin: "0%",
    },
  },
  request_button_group: {
    display: "flex",
    flexDirection: "row",
    marginTop: "15px",
    "@media (max-width: 640px)": {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  request_button2: {
    borderRadius: ".5rem",
    width: "auto",
    border: "none",
    padding: "10px",
    background: PrimaryColor,
    color: White,
    cursor: "pointer",
    "&:hover": {
      //background: LightPrimaryColor,
      transition: "transform 0.3s ease",
      transform: "translateY(-5px)",
    },
    "@media (max-width: 640px)": {
      fontSize: "0.9rem",
      marginTop: "5%",
      width: "10rem",
    },
  },
  request_button3: {
    borderRadius: ".5rem",
    width: "auto",
    border: "2px solid",
    padding: "10px",
    marginLeft: "5%",
    backgroundColor: BackgroundBlue,
    color: PrimaryColor,
    cursor: "pointer",
    "&:hover": {
      // background: LightPrimaryColor,
      // color: White,
      transition: "transform 0.3s ease",
      transform: "translateY(-5px)",
    },
    "@media (max-width: 640px)": {
      fontSize: "0.9rem",
      marginTop: "5%",
      marginLeft: "0%",
      width: "10rem",
    },
  },
  link: {
    color: PrimaryColor,
    "&:hover": {
      color: LightPrimaryColor,
    },
  },
  // Recent Work
  recentWorkContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    background: White,
  },
  recentWorkTitle: {
    width: "100%",
    fontSize: "2rem",
    fontWeight: "700",
    wordWrap: "break-word",
    color: PrimaryColor,
    marginTop: "3rem",
    marginBottom: "3rem",
    "@media (max-width: 640px)": {
      fontSize: "1.3rem",
      marginTop: "1rem",
      marginBottom: "1rem",
    },
  },
  recentWorkCarrousel: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    padding: "20px 0",
    marginLeft: "1rem",
    marginRight: "1rem",
    "@media (max-width: 640px)": {
      flexDirection: "column",
      marginLeft: "0%",
      marginRight: "0%",
      padding: "0",
      margin: "10px",
    },
  },
  recentWorkImage: {
    width: "20% !important",
    height: "400px",
    objectFit: "cover",
    borderRadius: "10px",
    // "@media (max-width: 1440px)": {
    //   width: "350px !important",
    // },
    // "@media (max-width: 1340px)": {
    //   width: "300px !important",
    // },
    // "@media (max-width: 1240px)": {
    //   width: "270px !important",
    // },
    "@media (max-width: 640px)": {
      width: "80% !important",
      height: "250px",
      marginBottom: "1rem",
    },
  },
  prevNextButton: {
    background: PrimaryColor,
    "@media (max-width: 640px)": {
      display: "none",
    },
    "&:hover": {
      background: LightPrimaryColor,
      color: White,
    },
  },
  recentButtonContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    width: "100%",
    padding: "0 6rem",
    marginTop: "2rem",
    marginBottom: "2rem",
    "@media (max-width: 640px)": {
      alignItems: "center",
      padding: "0 1rem",
    },
  },
  recentDiv1: {
    fontSize: "1.5rem",
    fontWeight: "700",
    color: PrimaryColor,
    marginLeft: "1rem",
    cursor: "pointer",
    "&:hover": {
      color: LightPrimaryColor,
    },
  },
  carouselDots: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "0.5rem",
    marginTop: "1rem",
  },
  dot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    background: PrimaryColor,
    cursor: "pointer",
    "&.active": {
      width: "12px",
      height: "12px",
    },
  },
}));
